var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ma-media-gallery-overlay",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          $event.stopPropagation()
          return _vm.handleClose.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "ma-gallery-container",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "ma-gallery-header" }, [
            _c("div", { staticClass: "ma-gallery-file-info" }, [
              _c("span", { staticClass: "ma-gallery-file-name" }, [
                _vm._v(
                  _vm._s(
                    _vm.currentAsset.name ||
                      _vm.$t("tables.mediaGalleryUntitled")
                  )
                ),
              ]),
              _vm._v(" "),
              _vm.assets.length > 1
                ? _c("span", { staticClass: "ma-gallery-counter" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.currentIndex + 1) +
                        " / " +
                        _vm._s(_vm.assets.length) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ma-gallery-header-actions" },
              [
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.downloadFile") } },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "ma-gallery-action-btn",
                        attrs: { type: "link" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleDownload.apply(null, arguments)
                          },
                        },
                      },
                      [_c("a-icon", { attrs: { type: "download" } })],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.openInNewTab") } },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "ma-gallery-action-btn",
                        attrs: { type: "link" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleOpenInNewTab.apply(null, arguments)
                          },
                        },
                      },
                      [_c("a-icon", { attrs: { type: "export" } })],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "ma-gallery-action-btn ma-gallery-close-btn",
                    attrs: { type: "link" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleClose.apply(null, arguments)
                      },
                    },
                  },
                  [_c("a-icon", { attrs: { type: "close" } })],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.assets.length > 1
            ? _c(
                "button",
                {
                  staticClass: "ma-gallery-nav ma-gallery-nav-prev",
                  attrs: {
                    type: "button",
                    disabled: _vm.currentIndex === 0,
                    "aria-label": _vm.$t("table.mediaGalleryPrevious"),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.goToPrev.apply(null, arguments)
                    },
                  },
                },
                [_c("a-icon", { attrs: { type: "left" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.assets.length > 1
            ? _c(
                "button",
                {
                  staticClass: "ma-gallery-nav ma-gallery-nav-next",
                  attrs: {
                    type: "button",
                    disabled: _vm.currentIndex === _vm.assets.length - 1,
                    "aria-label": _vm.$t("table.mediaGalleryNext"),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.goToNext.apply(null, arguments)
                    },
                  },
                },
                [_c("a-icon", { attrs: { type: "right" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "ma-gallery-body" }, [
            _vm.variant === "image" && _vm.currentUrl
              ? _c("div", { staticClass: "ma-gallery-image-wrap" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.currentUrl,
                      alt: _vm.currentAsset.name || "",
                    },
                  }),
                ])
              : _vm.variant === "video" && _vm.currentUrl
              ? _c("div", { staticClass: "ma-gallery-video-wrap" }, [
                  _c("video", {
                    key: _vm.mediaElementKey,
                    staticClass: "ma-gallery-video",
                    attrs: {
                      src: _vm.currentUrl,
                      controls: "",
                      playsinline: "",
                    },
                  }),
                ])
              : _vm.variant === "audio"
              ? _c("div", { staticClass: "ma-gallery-audio-wrap" }, [
                  _vm.currentUrl
                    ? _c(
                        "div",
                        { staticClass: "ma-gallery-audio-inner" },
                        [
                          _c("a-icon", {
                            staticClass: "ma-gallery-audio-deco",
                            attrs: { type: "sound" },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ma-gallery-audio-play-row" },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "ma-gallery-audio-play-btn",
                                  attrs: {
                                    type: "primary",
                                    shape: "circle",
                                    size: "large",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.toggleGalleryAudio.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", {
                                    attrs: {
                                      type: _vm.audioPlaying
                                        ? "pause"
                                        : "caret-right",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("audio", {
                            key: _vm.mediaElementKey,
                            ref: "galleryAudio",
                            staticClass: "ma-gallery-audio-el",
                            attrs: {
                              src: _vm.currentUrl,
                              controls: "",
                              preload: "auto",
                              playsinline: "",
                            },
                            on: {
                              play: _vm.onGalleryAudioPlay,
                              pause: _vm.onGalleryAudioPause,
                              ended: _vm.onGalleryAudioEnded,
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "ma-gallery-audio-missing" },
                        [
                          _c("a-icon", {
                            attrs: { type: "exclamation-circle" },
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("table.audioSourceMissing"))),
                          ]),
                        ],
                        1
                      ),
                ])
              : _vm.variant === "file"
              ? _c("div", { staticClass: "ma-gallery-file-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "ma-gallery-file-panel" },
                    [
                      _c("a-icon", {
                        staticClass: "ma-gallery-file-bigicon",
                        attrs: { type: _vm.antFileIcon(_vm.currentAsset) },
                      }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "ma-gallery-file-title" }, [
                        _vm._v(_vm._s(_vm.currentAsset.name || "—")),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ma-gallery-file-actions" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleDownload.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("a-icon", { attrs: { type: "download" } }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("table.downloadFile")) +
                                  "\n                        "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleOpenInNewTab.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("a-icon", { attrs: { type: "export" } }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("table.openInNewTab")) +
                                  "\n                        "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.assets.length > 1
            ? _c(
                "div",
                { staticClass: "ma-gallery-thumbs" },
                _vm._l(_vm.assets, function (asset, index) {
                  return _c(
                    "div",
                    {
                      key: asset._id || index,
                      staticClass: "ma-gallery-thumb",
                      class: { active: index === _vm.currentIndex },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goToIndex(index)
                        },
                      },
                    },
                    [
                      _vm.variant === "image" && _vm.thumbUrl(asset)
                        ? _c("img", {
                            attrs: {
                              src: _vm.thumbUrl(asset),
                              alt: asset.name || "",
                            },
                          })
                        : _vm.variant === "video"
                        ? [
                            _c("a-icon", {
                              staticClass: "ma-gallery-thumb-icon",
                              attrs: { type: "video-camera" },
                            }),
                          ]
                        : _vm.variant === "audio"
                        ? [
                            _c("a-icon", {
                              staticClass: "ma-gallery-thumb-icon",
                              attrs: { type: "sound" },
                            }),
                          ]
                        : [
                            _c("a-icon", {
                              staticClass: "ma-gallery-thumb-icon",
                              attrs: { type: _vm.antFileIcon(asset) },
                            }),
                          ],
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }